const moment = require('moment')
const XLSX = require('xlsx');
const { sheet_to_json } = require('xlsx').utils
import config from '@/config';
import utils from '@/utils'
export const groupBySum = (items, groupByProp, sumProp) => {
  var groups = new Map();
  for (const item of items) {
    if (item[groupByProp] && item[sumProp]) {
      const groupBy = item[groupByProp];
      if (groups.has(groupBy)) {
        const currentValue = groups.get(groupBy);
        groups.set(groupBy, currentValue + item[sumProp]);
      } else {
        groups.set(groupBy, item[sumProp]);
      }
    }
  }
  const sums = [];
  for (const [key, value] of groups) {
    sums.push({
      [groupByProp]: key,
      [sumProp]: value
    });
  }
  return sums;
};

const TYPE = {
  OBJECT: 'object',
  PRIMITIVE: 'primitive'
}

const func = {
  /**
   * Remove an element from array
   * @param {*} arr array need to work on
   * @param {*} val value to compare
   * @param {*} fieldName (Optional) field name to compare
   * @param {*} type object or primitive data
   */
  removeElementFromArray(arr, val, type, fieldName) {
    let index = arr.findIndex(e => {
      return type === TYPE.OBJECT ? e[fieldName] === val : e === val;
    });
    if (index === -1) {
      return;
    }
    arr.splice(index, 1);
  },
  /**
   * Remove an element from array
   * @param {*} arr array need to work on
   * @param {*} val value to compare
   * @param {*} fieldName (Optional) field name to compare
   * @param {*} type object or primitive data
   * @param {*} platform (Optional) platform to compare
   */
  removePairingElementFromArray(arr, val, type, fieldName, platform) {
    let index = arr.findIndex(e => {
      return type === TYPE.OBJECT ? e[fieldName] === val && e.platform === platform : e[fieldName] === val && e.platform === platform;
    });
    if (index === -1) {
      return;
    }
    arr.splice(index, 1);
  },
  /**
   * Push new element into array without duplicated
   * @param {*} arr array we are working on
   * @param {*} element element need to insert
   * @param {*} fieldName field to compare
   * @param {*} type object or primitive data
   */
  pushElementToArray(arr, element, fieldName, type) {
    if (!arr) return false;
    let index = arr.findIndex(e => {
      return type === TYPE.OBJECT ? e[fieldName] === element[fieldName] : e === element;
    });
    if (index !== -1) {
      arr[index] = element;
    } else {
      arr.push(element);
    }
  },
  /**
   * Push new pairing element into array without duplicated
   * @param {*} arr array we are working on
   * @param {*} element element need to insert
   * @param {*} fieldName field to compare
   * @param {*} type object or primitive data
   */
  pushPairingElementToArray(arr, element, fieldName, type, platform) {
    if (!arr) return false;
    let index = arr.findIndex(e => {
      return type === TYPE.OBJECT ? e[fieldName] === element[fieldName] && e.platform === platform : e === element;
    });
    if (index !== -1) {
      arr[index] = element;
    } else {
      arr.push(element);
    }
  },
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {
      type: mime
    });
  },
  extractHashTagsFromString(str) {
    const regex = /#[a-z0-9A-Z]+/gm;
    let m;
    let hashTags = []
    while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match) => {
        hashTags.push(match)
      });
    }
    return hashTags
  },
  clean(obj) {
    let returnObj = Object.assign(obj)
    for (var propName in returnObj) {
      if (returnObj[propName] === null || returnObj[propName] === undefined) {
        delete returnObj[propName];
      } else {
        if (returnObj[propName] && returnObj[propName] !== undefined && typeof returnObj[propName] === 'string') returnObj[propName] = returnObj[propName].trim()
      }
    }
    return returnObj
  },
  getDate() {
    let date = new Date()
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  },
  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  },
  formatCurrency(number) {
    // return number.toLocaleString('sg-SG', {
    //   style: 'currency',
    //   currency: 'SGD',
    //   minimumFractionDigits: 0
    // });
    if (number !== '' && number !== undefined && number !== 0 && number !== '0' && number !== null) {
      return 'SGD ' + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return number;
    }
  },
  changeDateFormat: (date) => moment(date).format('DD-MM-YYYY'),
  formatCustomDate: (date, format) => moment(date).format(format),
  extractShortCode(url) {
    var matches;
    if ((matches = url.match(/\/p\/([^\/]+)[\/|?]/)) !== null) {
      return matches[1]
    };
    return null
  },
  /**
   * Get all keys of objects as array
   * @param {*} obj
   * @param {*} prefix
   */
  keyify(obj, prefix = '') {
    if (!obj) return []
    return Object.keys(obj).reduce((res, el) => {
      if (Array.isArray(obj[el])) {
        return res;
      } else if (typeof obj[el] === 'object' && obj[el] !== null) {
        return [...res, ...this.keyify(obj[el], prefix + el + '.')];
      } else {
        return [...res, prefix + el];
      }
    }, []);
  },
  constructImageURL: function (imageName) {
    return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
  },
  constructWebImageURL: function (path) {
    const protocol = window.location.protocol
    const host = window.location.host
    return `${protocol}//${host}${path}`
  },
  cutStringAfterLast: function (value, cutter) {
    return value.substring(value.lastIndexOf(cutter) + 1);
  },
  objectToQueryString(object = {}) {
    const searchParams = new URLSearchParams(object);
    return searchParams.toString()
  },
  getInstagramAuthURL(query = {}, path) {
    const protocol = window.location.protocol
    const host = window.location.host
    // Convert query object to query string
    const searchParams = new URLSearchParams()
    Object.keys(query).forEach((key) => searchParams.append(key, query[key]));
    return `${protocol}//${host}${path}?${searchParams.toString()}`
  },
  getQuarterRange(quarter) {
    switch (quarter) {
      case 1:
        return {
          from: moment().set('month', 0).startOf('month'),
          to: moment().set('month', 2).endOf('month')
        }
      case 2:
        return {
          from: moment().set('month', 3).startOf('month'),
          to: moment().set('month', 5).endOf('month')
        }
      case 3:
        return {
          from: moment().set('month', 6).startOf('month'),
          to: moment().set('month', 8).endOf('month')
        }
      case 4:
        return {
          from: moment().set('month', 9).startOf('month'),
          to: moment().set('month', 11).endOf('month')
        }
    }
  },
  copyToClipboard(elementid) {
    let copyText = document.querySelector(elementid)
    copyText.setAttribute('type', 'text')    // hidden
    copyText.select()

    try {
      document.execCommand('copy')
      copyText.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()

      return true
    } catch (err) {
      return false
    }
  },
  parserToJson(filePath) {
    const workbook = XLSX.read(filePath, {
      type: 'buffer',
      sheetStubs: true,
      cellDates: true
    });
    const sheetNameList = workbook.SheetNames;
    let json = []
    for (let y of sheetNameList) {
      const worksheet = workbook.Sheets[y];
      const data = sheet_to_json(worksheet, {blankrows: false, raw: false})
      json.push(data)
    }
    return json;
  },
  numToAlphabet(num) {
    return (num + 9).toString(36).toUpperCase()
  },
  refreshJSON(json) {
    return JSON.parse(JSON.stringify(json || []))
  },
  formatDate(date) {
    if (!date) return null;
    const [year, month, day] = date.split('-');
    let formattedDate = `${day}/${month}/${year}`
    if (formattedDate.includes('undefined')) {
      return date
    }
    return formattedDate;
  },
  parseDate(date) {
    if (!date) return null;
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  },
  parseMonth(date) {
    /* eslint-disable */
    if (!date) return null;
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}`;
  },
  escapeSpecialChars(value) {
    return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  },
  escapeCldSpecialChars(value) {
    return value.replace(/[?&#\/%<>]/gi, '');
  },
  espaceHandleSign(value) {
    if(!value) return value
    return value.replace('@', '').toLowerCase()
  },
  espaceHandleSignNoLower(value) {
    if(!value) return value
    return value.replace('@', '')
  },
  regexMatchIg(value, regex) {
    if(!value) return value
    if (value.match(regex)) {
      let searchTerm = regex.exec(value)
      if (searchTerm.length > 1) {
        return searchTerm[1]
      }
    }
    return value
  },
  regexMatch(value, regex) {
    if(!value) return value
    if (value.match(regex)) {
      let searchTerm = regex.exec(value)
      return searchTerm[0]
    }
    return value
  },
  extractTikTokHandle(value) {
    if (value.includes('@')) {
      value = value.substring(value.indexOf('@') + 1)
    }
    return value
  },
  toDataURL(url) {
    return fetch(url)
      .then(response => response.blob())
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      )
  },
  getCredibilityColor(credibility) {
    if (credibility >= 0 && credibility < 30) {
      return '#f44336';
    } else if (credibility >= 30 && credibility < 50) {
      return '#f9a825';
    } else {
      return '#4caf50';
    }
  },
  weekOfMonth() {
    var d = new Date();
    var date = d.getDate();
    var day = d.getDay();
    var weekNum = Math.ceil((date - 1 - day) / 7);
    return weekNum + 1
  },
  weekDurations(startDate) {
    startDate = moment(startDate, 'YYYY-MM')
    var todayDate = moment()
    var diff = todayDate.diff(startDate, 'week');
    return diff
  },
  monthDurations(startDate, endDate) {
    if (!startDate || !endDate) return '';
    const formattedStartDate = moment(startDate).format('YYYY-MM');
    const formattedEndDate = moment(endDate).format('YYYY-MM');
    return moment(formattedEndDate).diff(formattedStartDate, 'months', true) + 1
  },
  dayDurations(startDate, endDate) {
    if (!startDate || !endDate) return '';
    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    if (formattedStartDate === formattedEndDate) return 1
    return moment(formattedEndDate).diff(formattedStartDate, 'days', true)
  },
  totalWeeksOfMonth() {
    return Math.round(moment().daysInMonth() / 7);
  },
  formatMonth(date) {
    return moment(date).format('MMM YYYY')
  },
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },
  getFixedClr() {
    const fixedDarkColors = [
      "#1A1A2E", // Dark Blue
      "#162447", // Dark Navy
      "#0F3460", // Dark Slate
      "#53354A", // Dark Purple
      "#BB86FC", // Light Dark Purple
      "#1F1F2E", // Dark Charcoal
      "#5a5757", // Silver (light dark)
      "#4B0082", // Indigo
      "#2B2D42", // Dark Gray
      "#D9BF77"  // Tan (dark)
    ];
    for (let i = fixedDarkColors.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [fixedDarkColors[i], fixedDarkColors[j]] = [fixedDarkColors[j], fixedDarkColors[i]];
    }
    return fixedDarkColors[0];
  },
  async downloadFile(name, url) {
    return new Promise((resolve, reject) => {
      fetch(url)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        resolve(true)
      })
      .catch(() => reject('file download error!'));
    })
  },
  downloadURI(uri, name) {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  async checkURLExist(URL) {
    return new Promise((resolve, reject) => {
      fetch(URL)
      .then(resp => {
        resolve(resp.status === 200 || false)
      })
      .catch(() => resolve(false))
    })
  },
  escapeFirstChar(str, char) {
    if (!str || typeof str !== 'string') return str
    if (str.charAt(0) === char) {
      return str.substring(1)
    }
    return str
  },
  isDateFormatValid(givenDate) {
    let regex = config.regexPattern.date_format
    if (givenDate.match(regex)) return true
    return false
  },
  getDaysDiff(dateVal) {
    if (!dateVal || !utils.func.isDateFormatValid(dateVal)) return ''
    const dayDurations = utils.func.dayDurations(moment(), utils.func.parseDate(dateVal))
    return dayDurations > 0 ? `+${dayDurations}` : dayDurations
  },
  getLatestDate(firstDate, lastDate, format) {
    if (!firstDate && !lastDate) {
      return ''
    } else if (firstDate && !lastDate) {
      return moment(firstDate).format(format)
    } else if (lastDate && !firstDate) {
      return moment(lastDate).format(format)
    }
    firstDate = moment(firstDate).format('YYYY-MM-DD');
    lastDate = moment(lastDate).format('YYYY-MM-DD');
    return firstDate > lastDate ? moment(firstDate).format(format) : moment(lastDate).format(format)
  },
  reduceDays(dateVal, reduceCount, format) {
    if (!dateVal) return ''
    return moment(dateVal).subtract(reduceCount, 'day').format(format)
  },
  addDays(dateVal, reduceCount, format) {
    if (!dateVal) return ''
    return moment(dateVal).add(reduceCount, 'day').format(format)
  },
  getMonthNo(month) {
    let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let matchMonthIdx = shortMonths.indexOf(month)
    if (matchMonthIdx !== -1) {
      if (matchMonthIdx < 9) {
        return `0${matchMonthIdx + 1}`
      } else {
        return `${matchMonthIdx + 1}`
      }
    }
  },
  getFileNameFromURL(url) {
    let parts = url.split('/');
    let parsedURL = parts[parts.length - 1];
    return parsedURL
  },
  generatePassword() {
    const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const allCharacters = upperCaseLetters + lowerCaseLetters + numbers;
    let password = '';
    for (let i = 0; i < 8; i++) {
      password += allCharacters.charAt(Math.floor(Math.random() * allCharacters.length));
    }
    return password;
  },
  currencySym(name) {
    let currencies = config.currencySymbols
    let matchCurrency = currencies.find(c => c.title === name)
    if (matchCurrency) {
      return matchCurrency.symbol
    }
    return '$'
  },
  convertCurrency(currency, amt, currencyRates) {
    // convert rate if not sgd
    let rate = currencyRates[currency]
    amt = Number(amt / rate).toFixed(2)
    return amt
  },
  convertOtherCurrency(currency, amt, currencyRates) {
    // convert rate if not sgd
    let rate = currencyRates[currency]
    amt = Number(amt * rate).toFixed(2)
    return amt
  },
  generateUniqueId() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 26; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }
}
export default {
  func,
  TYPE
}



// WEBPACK FOOTER //
// ./src/utils/index.js